export * from './quickCheckoutSelectors';
export const SET_DATA = 'mp/quickCheckout/SET_DATA';

export const initialState = {
  quickCheckout: {}
};

export const quickCheckout = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export const setQuickCheckoutData = productData => {
  return {
    type: SET_DATA,
    payload: {
      quickCheckout: productData
    }
  };
};

export default quickCheckout;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/quickCheckout/quickCheckout.js
 **/